<template>
  <mv-page>
    <v-flex slot="header" xs12 hidden-sm-and-down>
    </v-flex>
    <mv-default-row>
      <v-layout row wrap class="px-1">
        <v-flex xs12 sm12 md4 lg4>
          <h2 class="font-weight-light">
            Вход в систему
          </h2>
          <v-form ref="form">
            <v-text-field
              autocomplete
              name="login"
              v-model="card"
              type="text"
              label="школьная карта"
              required
              outline
              append-icon="credit_card"
              :disabled="resetkey !== null"
              @keyup.enter="$refs.ipassword.focus"
            ></v-text-field>
            <v-text-field
              autocomplete
              name="password"
              ref="ipassword"
              v-model="password"
              :label="restoreBlocked ? 'введите новый пароль' : 'пароль'"
              type="password"
              required
              outline
              append-icon="lock"
            ></v-text-field>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-flex v-if="restoreBlocked && resetkey">
                <i class="grey--text">используется ключ восстановления</i>
              </v-flex>
            </v-card-actions>
            <v-btn outline block large color="primary" @click.native.stop="login" :disabled="!valid">Продолжить</v-btn>
            <LoginWithSberId/>
          </v-form>
        </v-flex>
        <v-flex d-flex sm12 md1></v-flex>
        <v-flex sm12 md7 lg7 d-flex>
          <v-card light color="amber lighten-3" class="mb-1">
            <v-card-text>
              <p>
                Если вы ранее не регистрировались, то пройдите процедуру <a href='/#/signup'>регистрации.</a>
              </p>
              <div style="border:4px;border-color:#fc4103;border-style:solid;">
                <v-icon>picture_as_pdf</v-icon><b><a href="/docs/Личный кабинет инструкция для родителя 2026.pdf" target="_blank">Инструкция пользования личным кабинетом для родителей</a></b>
                <br><br>
                <v-icon>picture_as_pdf</v-icon><b><a href="/docs/Памятка ПО ИСПОЛЬЗОВАНИЮ транспортной карты 2026.pdf" target="_blank">Памятка по использованию электронной карты</a></b>
                <br><br>
                <v-icon>picture_as_pdf</v-icon><b><a href="/docs/Bank_card_registration_memo.pdf" target="_blank">Памятка по добавлению банковской карты</a></b>
              </div>
              <br />
              <p><b>Забыли пароль?</b></p>
              <p>
                Если вы привязывали адрес <b>электронной почты</b>, то нажмите <a href="/#/restorepassword">сюда</a>
              </p>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </mv-default-row>
  </mv-page>
</template>
<script>
import LoginWithSberId from '@/components/LoginWithSberId.vue';
// eslint-disable-next-line
const cardRe = /^[\d]{6,9}$/i
export default {
  name: 'login',
  components: {
    LoginWithSberId
  },
  data: () => ({
    card: null,
    password: null,
    restoreBlocked: false,
    resetkey: null,
    sberToken: null
  }),
  computed: {
    validCard () {
      if (!this.card) return false
      return cardRe.test(this.card)
    },
    validPassword () {
      if (!this.password) return false
      if (this.password.length < 4) return false
      return true
    },
    valid () {
      return this.validCard && this.validPassword
    },
  },
  methods: {
    async login () {
      try {
        if (!this.valid) return
        if (this.resetkey) {
          const { meta } = await this.$store.dispatch('sioRequest', {
            topic: 'auth-set-password',
            pl: {
              secret: this.resetkey,
              newpassword: this.password
            }
          })
          this.$store.dispatch('snack', meta.msg)
        }
        const cardid = ('000' + this.card).slice(-9)
        const password = this.password
        this.$store.dispatch('login', { cardid, password, scope: 'default' })
      } catch (err) {
        this.$store.dispatch('snack', err)
      }
    }
  },
  mounted () {
    this.card = this.$route.query.cardid
    if (this.card) {
      console.log('restoring ', this.card)
      this.restoreBlocked = true
      this.resetkey = this.$route.query.resetkey
    }
  }
}
</script>

<style lang="css" scoped>
.sber-button {
  background: linear-gradient(10deg, rgb(241, 233, 19) 0%, rgb(146, 200, 36) 35%, rgb(50, 166, 53) 100%) !important;
  color: white !important;
  padding: 10px 20px !important;
  border: none !important;
  border-radius: 6px !important;
  cursor: pointer !important;
  margin-right: 10px !important;
}
</style>
